import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../../service.service';

@Component({
	selector: 'app-service-additional',
	templateUrl: './service-additional.component.html',
	styleUrls: ['./service-additional.component.scss'],
})
export class ServiceAdditionalComponent {
	constructor(public service: ServiceService) {}
}
